module.exports = __webpack_public_path__ + "img/rem-koolhaas_0.21c725fe.png";